module.exports = __webpack_public_path__ + "static/media/mb_map.0b83c20e.jpg";